import * as React from "react";
import { Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import CloseIcon from "@mui/icons-material/Close";
import { CanActions } from "../../interfaces/policy";
import Can from "../../containers/Policy/Can";

// @ts-expect-error - css
import styles from "./styles.module.css";

interface PropsType {
  actions: Array<{
    label: string | React.JSX.Element;
    action: () => void;
    Icon: any;
    dataTestmation: string;
    accessKey: CanActions;
  }>;
  onClose?: () => void;
  disableEdit?: boolean;
}

const ActionBar = ({ actions, onClose, disableEdit }: PropsType): React.ReactNode => (
  <Box className={styles.root}>
    {actions.map(({ action, Icon, label, dataTestmation, accessKey }, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Can key={`${label}${i}`} policyAccessKey={accessKey === undefined ? "allow" : accessKey}>
        <Tooltip
          style={{ zIndex: 1 }}
          title={label}
          slotProps={{
            popper: {
              disablePortal: true
            }
          }}
        >
          <IconButton
            className={styles.button}
            onClick={action}
            data-testmation={dataTestmation}
            disabled={i === 2 && disableEdit}
            size="large"
          >
            <Icon className={styles.icon} />
          </IconButton>
        </Tooltip>
      </Can>
    ))}

    {onClose && (
      <IconButton
        key="closeIconBtn"
        style={{ marginLeft: "16px" }}
        className={`${styles.button} ${styles.closeBtn}`}
        onClick={onClose}
        data-testmation="closeIcon"
        size="large"
      >
        <CloseIcon className={styles.icon} />
      </IconButton>
    )}
  </Box>
);

export default ActionBar;
